import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import {
  ParagraphEntity,
  ImmutableEntity,
} from '@uncinc/react-drupal-core/types';

import './style.scss';

interface ParagraphThemesOverviewProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<ParagraphEntity>;
}

const ParagraphThemesOverview: React.FC<ParagraphThemesOverviewProps> = ({ entity }) => {
  const paragraph = entity.toJS();

  return (
    <div className="Paragraph ParagraphThemesOverview">
      <Container>
        <View
          classes="row"
          id="theme"
          display="overview"
          withProvider
        />
      </Container>
    </div>
  );
};

export default ParagraphThemesOverview;
